<div class="container-fluid bg-white h-100">
    <div class="row">
        <div class="col-md-6">
            <div class="d-flex mt-4 font-weight-bolder">
                <span class="pr-2"
                    ><img id="profimgsize" class="imageAlign rounded h-25px w-25px" src="/assets/common/images/photos/Dashboard_title.png"
                /></span>
                <span class="mt-0-3">{{ "WelcomeBack" | localize }}</span>
            </div>
            <div *ngIf="isLoaded && !isEmpty" class="d-flex mt-4 checkImge">
                <!-- <div class="d-flex align-items-center w-35px h-35px">
                    <div class="d-flex">
                        <span class="users-useroverlays label label-dot "
                          pTooltip={{getUserStatus(userDetails.userStatusId)}} tooltipPosition="top"
                          [ngClass]="statusOptions[userDetails.userStatusId]"> &nbsp; </span>

                    </div>
                    <div class="d-flex align-items-end rounded w-100">
                        <img *ngIf="userDetails.profileImage" id="profimgsize" class="border border-light rounded img-fluid h-35px"
                        [src]="userDetails.profileImage">

                        <img *ngIf="!userDetails.profileImage" id="profimgsize"  class="border border-light rounded img-fluid" src="assets/common/images/default-profile-picture1.svg"/>
                    </div>
                </div>     -->
                <div class="users_img">
                    <span class="label-circle"></span>
                    <span
                        class="overlays label label-dot status-icon"
                        pTooltip="{{ getUserStatus(currentUserStatus) }}"
                        tooltipPosition="top"
                        [ngClass]="statusOptions[currentUserStatus]"
                    ></span>

                    <div class="d-flex align-items-center" *ngIf="userDetails.profileImage">
                        <div class="rounded h-35px w-35px">
                            <img [src]="userDetails.profileImage" id="profimgsize" class="border border-light rounded h-35px w-35px" />
                        </div>
                    </div>
                    <div class="d-flex align-items-center" *ngIf="!userDetails.profileImage">
                        <div class="rounded h-35px w-35px">
                            <img class="h-35px w-35px" src="assets/common/images/default-profile-picture1.svg" style="" id="profimgsize" />
                        </div>
                    </div>
                </div>
                <div class="d-lg-flex">
                    <h2
                        class="font-weight-boldest intime-open-sans pl-2"
                        pTooltip="{{ userDetails.userName }}"
                        [tooltipDisabled]="DisableTooltip(userDetails.userName, 16)"
                        tooltipPosition="bottom"
                    >
                        {{ userFullname(userDetails.userName) | slice : 0 : 15 }}{{ userFullname(userDetails.userName).length > 15 ? ".." : "" }}
                    </h2>
                    <span class="userDetails mt-2 ml-3" tooltipPosition="bottom">
                        {{ getDate | date : "fullDate" }} |
                        <img *ngIf="!userDetails.userCurrentLocation" src="assets/common/images/Activities/google-maps.svg" class="mr-2" />
                        <img
                            id="locationimg"
                            *ngIf="userDetails.userCurrentLocation && workingType == 1"
                            pTooltip="Work From Home"
                            tooltipPosition="bottom"
                            src="assets/common/images/Activities/wfh.svg"
                            class="mr-2"
                        />
                        <img
                            id="locationimg"
                            *ngIf="userDetails.userCurrentLocation && workingType == 3"
                            pTooltip="Work From Remote"
                            tooltipPosition="bottom"
                            src="assets/common/images/Activities/wfr.svg"
                            class="mr-2"
                        />
                        <img
                            id="locationimg"
                            *ngIf="userDetails.userCurrentLocation && workingType == 2"
                            pTooltip="Work From Office"
                            tooltipPosition="bottom"
                            src="assets/common/images/Activities/wfo.svg"
                            class="mr-2"
                        />
                        {{ userDetails.userCurrentLocation ? userDetails.userCurrentLocation : ("Unknown" | localize) }}
                    </span>
                    <span *ngIf="!isLoaded && isEmpty" class="h6 shimmeralignment">
                        <ngx-shimmer-loading [width]="'100px'" [height]="'25px'" class=""></ngx-shimmer-loading>
                    </span>
                </div>
            </div>
            <div *ngIf="!isLoaded && isEmpty" class="row mt-4">
                <ngx-shimmer-loading [width]="'150px'" [height]="'25px'"></ngx-shimmer-loading>
            </div>

            <div class="d-md-flex pt-9 pb-3">
                <div class="col-md-6 col-lg-4 pl-0">
                    <button
                        type="button"
                        *ngIf="userCurrentStatus !== 'CheckIn'"
                        class="btn btn-danger rounded cursor-pointer"
                        (click)="startAndStopTimer()"
                    >
                        <div class="row align-items-center">
                            <div class="col-md-3">
                                <div>
                                    <img src="../../../../../assets/common/images/Activities/AlarmIconDash.svg" height="25" />
                                </div>
                            </div>
                            <div class="col-md-9">
                                <div class="row text-left">
                                    <div class="col-md-12 font-weight-bold">
                                        {{ "ClockOut" | localize }}
                                    </div>
                                    <div class="col-md-12">
                                        {{ getLocalJsDate(checkInTime) | date : "hh:mm a" }}
                                        {{ getDate | date : "hh:mm a" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </button>
                    <button
                        type="button"
                        *ngIf="userCurrentStatus === 'CheckIn'"
                        class="btn checkInColor rounded cursor-pointer"
                        (click)="startAndStopTimer()"
                    >
                        <div class="row align-items-center">
                            <div class="col-3">
                                <div>
                                    <img src="../../../../../assets/common/images/Activities/AlarmIconDash.svg" height="25" />
                                </div>
                            </div>
                            <div class="col-9">
                                <div class="row text-left">
                                    <div class="col-md-12 font-weight-bold text-white">
                                        {{ "ClockIn" | localize }}
                                    </div>
                                    <div class="col-md-12 text-white">
                                        {{ getLocalJsDate(checkInTime) | date : "hh:mm a" }}
                                        {{ getDate | date : "hh:mm a" }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </button>
                </div>
                <div class="col-md-6 col-lg-4 mt-3" *ngIf="this.userCurrentStatus === 'CheckIn'">
                    <div class="row">
                        <span class="my-auto font-weight-bolder text-primary line-height-sm" style="font-size: 1.75rem; display: flex">
                            <!--{{currentTime | formatSecs | slice:0:5}}-->
                            <span *ngIf="!isLoaded"><ngx-shimmer-loading [width]="'90px'" [height]="'26px'"></ngx-shimmer-loading></span>
                            <span *ngIf="isLoaded">
                                {{ activeTime }}<span class="font-size-sm pt-3 pl-1"> {{ "h" | localize }}</span></span
                            >
                        </span>
                    </div>
                    <div class="row">
                        <div class="userDate">{{ "ActiveTime" | localize }}</div>
                    </div>
                </div>

                <div class="col-md-6 mt-3" *ngIf="this.userCurrentStatus !== 'CheckIn'">
                    <div class="row">
                        <span class="my-auto font-weight-bolder text-primary line-height-sm font-size-h1-xxl d-flex align-items-end">
                            <!--{{currentTime | formatSecs | slice:0:5}}-->
                            {{ activeTime }}
                            <span class="font-size-sm pl-1 pt-3"> {{ "h" | localize }}</span>
                        </span>
                    </div>
                    <div class="row">
                        <div class="userDate">{{ "ActiveTime" | localize }}</div>
                    </div>
                </div>
            </div>
            <div class="d-md-flex">
                <div class="col-md-6 mt-4 pl-0">
                    <div class="row">
                        <div class="col p-0 pr-2" style="text-align: right">
                            <span class="dot bg-danger" *ngIf="isLate"></span>
                            <span class="dot bg-success" *ngIf="!isLate"></span>
                        </div>
                        <div class="col-10 p-0 mt-2">
                            <span class="progress" style="height: 9px">
                                <div
                                    id="bar"
                                    class="progress-bar"
                                    role="progressbar"
                                    [ngStyle]="{ width: progressBarForTime + '%' }"
                                    aria-valuemin="0"
                                    aria-valuemax="100"
                                ></div>
                            </span>
                        </div>
                        <div class="col p-0 pl-2">
                            <span class="dot bg-danger" *ngIf="isearly"></span>
                            <span class="dot" *ngIf="!isearly && !isOnTime"></span>
                            <span class="dot bg-success" *ngIf="isOnTime"></span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-md-6">
                    <span class="projDetails"> {{ workStartTempTime | date : "h:mm a" }} </span>
                    <span class="projDetails float-right"> {{ workEndTempTime | date : "h:mm a" }} </span>
                </div>
            </div>

            <div class="row d-flex">
                <div
                    class="border border-radius-4px border-success d-flex mt-4 pl-0 col-md-7"
                    *ngIf="userDetails.applicationName"
                    style="background-color: #02bc771a"
                >
                    <div class="container-fluid p-0">
                        <div class="row">
                            <div class="col-md-6">
                                <div class="flex-grow-0 align-items-center gap-2 d-flex ps-3">
                                    <img [src]="userDetails.applicationIcon" class="img-fluid h-30px" />
                                    <span class="flex-grow-1 align-items-center mx-2 fw-bold text-decoration-none">
                                        <div>
                                            <!--<span>{{userDetails.applicationName}}</span>-->
                                            <span
                                                pTooltip="{{ userDetails.applicationName }}"
                                                [tooltipDisabled]="DisableTooltip(userDetails.applicationName, 10)"
                                                tooltipPosition="bottom"
                                            >
                                                {{ userDetails.applicationName | slice : 0 : 10 }}
                                                {{ userDetails.applicationName?.length > 10 ? "..." : "" }}
                                            </span>
                                            <div class="d-flex flex-column mb-0 text-muted">
                                                <div *ngIf="userDetails.productivityType == 1" class="font-size-14 text-success font-weight-bolder">
                                                    {{ "Productive" | localize }}
                                                </div>
                                                <div *ngIf="userDetails.productivityType == 2" class="font-size-14 font-weight-bold">
                                                    {{ "Unproductive" | localize }}
                                                </div>
                                                <div *ngIf="userDetails.productivityType == 3" class="font-size-14 font-weight-bold">
                                                    {{ "Neutral" | localize }}
                                                </div>
                                            </div>
                                        </div>
                                    </span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="flex-grow-0 align-items-center gap-2 d-flex px-3 mt-2">
                                    <img
                                        *ngIf="userDetails.deviceType == 1"
                                        src="../../../../assets/common/images/device-icon/WindowsDesktopGrey.svg"
                                        height="30"
                                    />
                                    <img
                                        *ngIf="userDetails.deviceType == 2"
                                        src="./../../../assets/common/images/device-icon/WebApplicationGrey.svg"
                                        height="30"
                                    />
                                    <img
                                        *ngIf="userDetails.deviceType == 3"
                                        height="30"
                                        src="../../../../assets/common/images/device-icon/MacDesktopGrey.svg"
                                    />
                                    <img
                                        *ngIf="userDetails.deviceType == 4"
                                        src=".. /../../../assets/common/images/device-icon/AndroidMobileGray.svg"
                                        height="30"
                                    />
                                    <img
                                        *ngIf="userDetails.deviceType == 5"
                                        src="../../../../assets/common/images/device-icon/MobileGrey.svg"
                                        height="30"
                                    />
                                    <span class="flex-grow-1 align-items-center mx-2 fw-bold text-decoration-none">
                                        <div>
                                            <span
                                                pTooltip="{{ userDetails.deviceName }}"
                                                [tooltipDisabled]="DisableTooltip(userDetails.deviceName, 10)"
                                                tooltipPosition="bottom"
                                            >
                                                {{ userDetails.deviceName | slice : 0 : 10 }} {{ userDetails.deviceName?.length > 10 ? "..." : "" }}
                                            </span>
                                            <p class="mb-0 text-muted" style="display: none">{{ "testtextis" | localize }}..</p>
                                        </div>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="border border-radius-4px d-flex mt-4 pl-0 col-md-7" style="border-color: #eeeeee" *ngIf="userDetails.projectName">
                    <div class="d-flex">
                        <div class="flex-grow-0 align-items-center gap-2 d-flex px-3">
                            <div class="d-flex align-items-center">
                                <div class="d-flex">
                                    <span
                                        class="count-badge"
                                        [ngClass]="{
                                            'count-badge-blue': userDetails.taskStateId === 1,
                                            'count-badge-orange': userDetails.taskStateId === 2,
                                            'count-badge-red': userDetails.taskStateId === 3,
                                            'count-badge-green': userDetails.taskStateId === 4
                                        }"
                                    ></span>
                                    <!-- <span class="users-useroverlays label label-dot "
                                      pTooltip={{getUserStatus(userDetails.userDetails.taskStateIdId)}} tooltipPosition="top"
                                      [ngClass]="statusOptions[userDetails.userDetails.taskStateIdId]"> &nbsp; </span> -->
                                </div>
                                <div class="d-flex justify-content-center align-items-end rounded w-100">
                                    <img
                                        *ngIf="userDetails.projectName"
                                        src="{{
                                            userDetails.projectIcon
                                                ? userDetails.projectIcon
                                                : 'assets/common/images/projects/default image for project -1.png'
                                        }}"
                                        class="h-30px"
                                        id="profimgsize"
                                    />
                                </div>
                            </div>

                            <span class="flex-grow-1 align-items-center ms-2 fw-bold text-decoration-none">
                                <div>
                                    <span
                                        >{{ userDetails.projectName | slice : 0 : 17 }} {{ userDetails.projectName?.length > 17 ? "..." : "" }}</span
                                    >
                                    <p class="mb-0 text-muted">
                                        {{ userDetails.projectDescription | slice : 0 : 17
                                        }}{{ userDetails.projectDescription?.length > 17 ? "..." : "" }}
                                    </p>
                                </div>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-md-6 mt-4">
            <div class="d-flex justify-content-between">
                <div class="font-weight-bolder">
                    <span class="pr-1">
                        <img
                            id="profimgsize"
                            class="imageAlign border border-light rounded h-25px w-25px"
                            src="/assets/common/images/photos/Dashboard_CurrentProject.svg"
                        />
                    </span>
                    {{ "CurrentProjects" | localize }}
                    <span class="badge badge-primary bg-transparent text-primary border-1 p-1 ml-1" style="border: 1px solid">
                        # {{ projectCount }}
                    </span>
                    <!-- <img id="profimgsize" class="imageAlign border border-light rounded h-25px w-25px"
                            src="/assets/common/images/photos/Dashboard_ProjectCount.png"> -->
                </div>
            </div>

            <div class="mt-1">
                <div class="bg-white flex-grow-1 card-custom-tabs1 position-relative" id="projectsTabs" *ngIf="isProjectDataLoaded">
                    <tabset #projectsTabs>
                        <tab *ngFor="let project of currentProjectDto; index as i">
                            <ng-template tabHeading>
                                <img id="profimgsize"
                                    class="m-2 imageAlign border border-light rounded h-35px w-35px p-1"
                                    pTooltip="{{ project.name }}" [tooltipDisabled]="DisableTooltip(project.name, 1)"
                                    tooltipPosition="bottom" src="{{
                                        project.projectImage ? project.projectImage : 'assets/common/images/projects/default image for project -1.png'
                                    }}" />
                            </ng-template>
                            <div class="d-flex justify-content-between">
                                <div class="mt-4 pl-0">
                                    <div>
                                        <span
                                            class="bg-white font-size-sm font-weight-boldest intime-open-sans mr-2"
                                            pTooltip="{{ project.name }}"
                                            [tooltipDisabled]="DisableTooltip(project.name, 16)"
                                            tooltipPosition="bottom"
                                        >
                                            {{ project?.name | slice : 0 : 16 }}{{ project?.name?.length > 16 ? "..." : "" }}
                                        </span>
                                        <span class="text-muted font-size-sm font-weight-bolder">
                                            {{ project.hourlyBudget }} {{ "hrs" | localize }}
                                        </span>
                                    </div>
                                </div>
                                <div class="mt-4 pr-0 text-right">
                                    <span
                                        *ngIf="project?.projectBillingType == 1"
                                        class="label label-outline-secondary label-pill label-inline mr-2"
                                        style="
                                            border-radius: 1.42rem !important;
                                            border-color: rgb(179, 181, 185) !important;
                                            font-size: 0.84rem;
                                            font-weight: 500;
                                        "
                                        ><span
                                            [ngClass]="{
                                                'label-success': project?.projectBillingType == 1,
                                                'label-warning': status == 2,
                                                'label-pill': status == 3
                                            }"
                                            class="label label-dot mr-2"
                                        ></span
                                        >{{ "Billable" | localize }}</span
                                    >
                                    <span
                                        *ngIf="project?.projectBillingType == 2"
                                        class="label label-outline-secondary label-pill label-inline mr-2"
                                        style="
                                            border-radius: 1.42rem !important;
                                            border-color: rgb(179, 181, 185) !important;
                                            font-size: 0.84rem;
                                            font-weight: 500;
                                        "
                                        ><span [ngClass]="{ 'label-warning': project?.projectBillingType == 2 }" class="label label-dot mr-2"></span
                                        >{{ "NonBillable" | localize }}</span
                                    >
                                </div>
                            </div>
                            <div class="d-md-flex justify-content-between">
                                <div class="col-lg-6 col-md-6 mt-4 pl-0">
                                    <div class="table-responsive">
                                        <table class="w-100" cellpadding="0" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <td style="border: 1px solid #e3e3e3">
                                                        <div class="p-3">
                                                            <span class="font-weight-boldest"> {{ project.startDate | date : "MMM d, y" }} </span>
                                                            <div class="text-muted font-size-sm font-weight-bolder">
                                                                {{ "StartDate" | localize }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                    <td style="border: 1px solid #e3e3e3">
                                                        <div class="p-3">
                                                            <span class="font-weight-boldest"> {{ project.endDate | date : "MMM d, y" }} </span>
                                                            <div class="text-muted font-size-sm font-weight-bolder">
                                                                {{ "EndDate" | localize }}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                </div>
                                <div class="col-md-5 mt-4 pr-0">
                                    <div class="projDetails">
                                        <span> {{ "ProgressBar" | localize }} </span>
                                    </div>
                                    <div class="progress" style="height: 9px">
                                        <div
                                            id="bar"
                                            class="progress-bar"
                                            role="progressbar"
                                            [ngStyle]="{ width: getProjectProgress(project.startDate, project.endDate) + '%' }"
                                            aria-valuemin="0"
                                            aria-valuemax="100"
                                        ></div>
                                    </div>
                                    <span class="projDetails"> {{ getProjectProgress(project.startDate, project.endDate) }}% </span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between">
                                <div class="col-md-3 mt-4 pl-0">
                                    <div class="d-flex flex-column text-dark-50">
                                        <span class="font-weight-bolder font-size-sm mb-2">{{ "Manager" | localize }}</span>

                                        <profile-image-chain
                                            [interactive]="false"
                                            [userDetails]="project.assignedProjectManager"
                                            [showConsolidatedViewLink]="false"
                                            class="profile-position"
                                        ></profile-image-chain>
                                    </div>
                                </div>
                                <div class="col-md-4 mt-4 ml-9">
                                    <div class="d-flex flex-column text-dark-50 pl-0">
                                        <span class="font-weight-bolder font-size-sm mb-2">{{ "TeamMember" | localize }}</span>
                                        <profile-image-chain
                                            [interactive]="false"
                                            [userDetails]="project.teamProfileImage"
                                            [showConsolidatedViewLink]="false"
                                            class="profile-position"
                                        ></profile-image-chain>
                                    </div>
                                </div>
                                <div class="col-md-5 mt-md-13 pr-0">
                                    <span
                                        (click)="redirectToViewPage(project.id, project.projectType)"
                                        type="button"
                                        class="font-size-14 font-weight-bolder text-primary d-flex align-items-center"
                                    >
                                        <span class="pt-3px"> {{ "ViewProject" | localize }}</span>
                                        <img class="h-18px w-18px ml-2 img-fluid" src="/assets/common/images/photos/Dashboard_ViewProject.png" />
                                    </span>
                                </div>
                            </div>
                        </tab>
                    </tabset>
                </div>

                <div *ngIf="!isProjectDataLoaded" class="mt-7">
                    <ngx-shimmer-loading [width]="'100%'" [height]="'150px'"></ngx-shimmer-loading>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-4 px-8">
        <!-- <div class="col-md-4 col-lg-4 p-0">
            <div class="d-flex">
                <div class="d-flex align-items-center">
                    <div class="d-flex justify-content-center align-items-end border border-light rounded p-1 w-100">
                        <img *ngIf="userDetails.projectName"
                            src="{{ userDetails.projectIcon ? userDetails.projectIcon : 'assets/common/images/projects/default image for project -1.png'}}"
                            class="m-2 w-35px h-35px" id="profimgsize">

                    </div>
                </div>
                <div class="d-flex flex-column ml-3 justify-content-center">
                    <div class="font-weight-bold" pTooltip="{{ userDetails.projectName }}"
                        [tooltipDisabled]="DisableTooltip( userDetails.projectName, 17)" tooltipPosition="bottom">
                        {{userDetails.projectName | slice:0:17}} {{ userDetails.projectName?.length > 17 ? '...':''}}
                    </div>
                    <div class="font-size-14 " pTooltip="{{ userDetails.projectDescription }}"
                        [tooltipDisabled]="DisableTooltip( userDetails.projectDescription , 17)"
                        tooltipPosition="bottom">{{ userDetails.projectDescription | slice:0:17}}{{
                        userDetails.projectDescription?.length > 17 ? '...':''}}</div>
                </div>
            </div>
        </div> -->

        <div *ngIf="!isLoaded && isEmpty" class="col-md-6 p-0">
            <span class="label rounded-pill h-50px w-310px mr-3 label-inline bg-secondary-o-20 border border-2 justify-content-start">
                <div class="d-flex">
                    <div class="d-flex align-items-center cursor-pointer">
                        <ngx-shimmer-loading [width]="'20px'" [height]="'20px'"></ngx-shimmer-loading>
                    </div>
                    <div class="d-flex flex-column cursor-pointer ml-3">
                        <ngx-shimmer-loading [width]="'80px'" [height]="'10px'"></ngx-shimmer-loading>
                    </div>
                    <div class="d-flex align-items-center cursor-pointer ml-5">
                        <div class="d-flex justify-content-center align-items-end mb-1 rounded w-70">
                            <ngx-shimmer-loading [width]="'20px'" [height]="'20px'"></ngx-shimmer-loading>
                        </div>
                    </div>
                    <div class="d-flex flex-column cursor-pointer ml-3">
                        <ngx-shimmer-loading [width]="'80px'" [height]="'10px'"></ngx-shimmer-loading>
                    </div>
                </div>
            </span>
        </div>
        <div *ngIf="isLoaded && !isEmpty" class="col-md-6 p-0">
            <!-- <span *ngIf="userDetails.applicationName" class="label  rounded-pill h-50px w-310px mr-3 label-inline  border border-2 justify-content-start " [ngClass]="{'bg-gray-100' : userDetails.productivityType == 3,'border-secondary' : userDetails.productivityType == 3,'bg-success-o-40' : userDetails.productivityType == 1,'border-success' : userDetails.productivityType == 1,'bg-secondary-0-45' : userDetails.productivityType == 2,'borderUnproductiveColor' : userDetails.productivityType == 2}">
                <div class="d-flex">
                    <div class="d-flex align-items-center cursor-pointer">
                        <div class="d-flex justify-content-center align-items-end mb-1 rounded w-70">
                            <img [src]="userDetails.applicationIcon" height="25" />
                        </div>
                    </div>
                    <div class="d-flex flex-column cursor-pointer ml-3">
                        <div class="font-weight-bold text-dark-75 fontColor">{{userDetails.applicationName}}</div>
                        <div *ngIf="userDetails.productivityType == 1" class=" font-size-14 text-success font-weight-bolder">{{'Productive' | localize}}</div>
                        <div *ngIf="userDetails.productivityType == 2" class=" font-size-14  font-weight-bold">{{'Unproductive' | localize}}</div>
                        <div *ngIf="userDetails.productivityType == 3" class=" font-size-14 font-weight-bold">{{'Neutral'| localize}}</div>

                    </div>
                    <div class="d-flex align-items-center cursor-pointer ml-5">
                        <div class="d-flex justify-content-center align-items-end mb-1 rounded ">
                            <img *ngIf="userDetails.deviceType == 1" src="../../../../assets/common/images/device-icon/WindowsDesktopGrey.svg" height="25" />
                            <img *ngIf="userDetails.deviceType == 2" src="./../../../assets/common/images/device-icon/WebApplicationGrey.svg" height="25" />
                            <img *ngIf="userDetails.deviceType == 3" src="../../../../assets/common/images/device-icon/MacDesktopGrey.svg" height="25" />
                            <img *ngIf="userDetails.deviceType == 4" src=".. /../../../assets/common/images/device-icon/AndroidMobileGray.svg" height="25" />
                            <img *ngIf="userDetails.deviceType == 5" src="../../../../assets/common/images/device-icon/MobileGrey.svg" height="25" />

                        </div>
                    </div>
                    <div class="d-flex flex-column cursor-pointer ml-3">
                        <div class="font-weight-bold text-dark-75 fontColor mt-1">{{userDetails.deviceName}}</div>
                    </div>


                </div>

            </span> -->
            <!--  <span *ngIf="!userDetails.applicationName" class="label  rounded-pill h-50px w-150px mr-3 label-inline bg-white border border-xl-2  border-secondary justify-content-start">
                <div class="d-flex align-item-center">

                    <div class="d-flex align-items-center cursor-pointer ml-5 mt-1">
                        <div class="d-flex justify-content-center align-items-end mt-1 rounded w-70">
                            <img src="assets/common/images/Activities/InactiveUserIcon.svg" width="25">
                        </div>
                    </div>
                    <div class="d-flex flex-column cursor-pointer ml-3 mt-2">
                        <div class="font-weight-bold text-dark-75 fontColor mt-1">Not applicable</div>
                    </div>


                </div>

            </span>-->
        </div>
    </div>
</div>
